import client from '../client'
import type { Texture } from '../types'

export function getAdminTextures(params: {
  cursor?: string | null
  limit?: number
  q?: string
  type?: string
}): Promise<{
  data: { items: Texture[]; has_next: boolean; next_cursor: string | null; page_size: number }
}> {
  return client.get('/v2/admin/textures', { params })
}

export function patchAdminTexture(
  hash: string,
  data: { type: string; model?: string; note?: string; is_public?: boolean | number },
): Promise<{ data: void }> {
  return client.patch(`/v2/admin/textures/${hash}`, data)
}

export function deleteAdminTexture(
  hash: string,
  params: { type?: string; user_id?: string; force?: boolean },
): Promise<{ data: void }> {
  return client.delete(`/v2/admin/textures/${hash}`, { params })
}
